import React from 'react';
import { useSelector } from 'react-redux';
import { isPandaV2Enabled } from 'shared/store/selectors/features.selector';
import { AskPandaChat } from './ask-panda-chat';
import { PandaChatV2 } from './panda-chat-v2';

/**
 * Routes to the new streaming, multi-source Panda chat (V2) when the per-org
 * `panda-v2` flag is on, otherwise the existing chat (V1). Both
 * self-gate on `isAIEnabled`, so flipping the flag off is the rollback path.
 */
export function AskPandaChatSwitch() {
  const usePandaV2 = useSelector(isPandaV2Enabled);
  return usePandaV2 ? <PandaChatV2 /> : <AskPandaChat />;
}
